import React, { useState , useRef } from "react"
import { useFormikContext } from "formik"
import { useToasts } from "react-toast-notifications"
import axios from "axios"
import { navigate } from "gatsby"


import FormError from "../../../formError"

const AdditionalDocuments = () => {
  const { addToast } = useToasts()
  const { values, errors, touched, setFieldValue } = useFormikContext()
const [fileWarrningText, setFileWarningText] = useState("")
  const [image, setImage] = useState("")
  const [url, setUrl] = useState("")
  const [loading, setLoading] = useState(false)
   const inputFileRef = useRef(null) 
  

  const uploadImage = (file_data, file_location) => {
    setLoading(true)
    const myHeaders = new Headers()
    myHeaders.append("Accept", "application/json")
    myHeaders.append("token", `${localStorage.getItem("mobile_token")}`)
    const data = new FormData()
    data.append("file", file_data, file_data.name)

    axios
      .post(
        `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/document-upload`,
        data,
        {
          headers: {
            Accept: "application/json",
            token: localStorage.getItem("mobile_token"),
          },
          redirect: "follow",
        }
      )
      .then((res) => {
        setFieldValue(file_location, res.data.data.file)
        setFieldValue(`${file_location}_name`, file_data.name)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        addToast(err.response.data.message, {
          appearance: "error",
          placement: "top-center",
          autoDismiss: true,
        })
        if (err.response.data.message === "Token expired") {
          navigate("/business-support/get-started/")
        }
        if (inputFileRef.current) {
          inputFileRef.current.value = ""
        }
      })
    
  }


  const setFile = (file, location) => {
     const maxFileSize = 5 * 1024 * 1024 // 5MB in bytes

     if (file.size > maxFileSize) {
       setFileWarningText("File size should not exceed 5MB.")
       addToast("File size should not exceed 5MB", {
         appearance: "error",
         placement: "top-center",
         autoDismiss: true,
       })
       if (inputFileRef.current) {
         inputFileRef.current.value = ""
       }
       setTimeout(() => setFileWarningText(""), 2000)

       return
     }
    uploadImage(file, location)
  }

  return (
    <div
      className={
        loading
          ? "progress_state form-row justify-content-center"
          : "form-row justify-content-center"
      }
    >
      <div className="form-group col-md-12">
        <label htmlFor="certificate_of_registration">
          A copy of your Certificate of registration
        </label>
        <input
          type="file"
          className="form-control border-0"
          id="certificate_of_registration"
          name="certificate_of_registration"
          accept="application/pdf"
          title="Accept pdf only"
          ref={inputFileRef}
          onChange={(e) =>
            setFile(e.target.files[0], "certificate_of_registration")
          }
        />

        <label
          htmlFor="certificate_of_registration"
          className="font-weight-light text-muted"
        >
          pdf file only
        </label>

        <FormError
          touched={touched.certificate_of_registration}
          message={errors.certificate_of_registration}
        />
      </div>
      {fileWarrningText && (
        <p className="sparkle--font__14 sparkle-bright-orange sparkle--weight__600">
          {fileWarrningText}
        </p>
      )}

      <p>{loading && "Processing"}</p>
    </div>
  )
}

export default AdditionalDocuments
